module.exports = __webpack_public_path__ + "static/img/MV.5d46e926.png";